export const CouponIssuerType = {
  1: 'ADMIN',
  2: 'MARKET',
};
